// Error boundary que captura erros de renderização do React
// e mostra mensagem útil ao invés de tela cinza/branca

import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { erro: null, info: null };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    console.error('[ErrorBoundary]', erro, info);
    this.setState({ info });
  }

  render() {
    if (this.state.erro) {
      const e = this.state.erro;
      return (
        <div style={{
          padding: '2rem',
          fontFamily: '-apple-system, "Segoe UI", Roboto, sans-serif',
          maxWidth: 800, margin: '50px auto',
          background: '#fff', borderRadius: 10,
          border: '2px solid #dc2626',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        }}>
          <h2 style={{ color: '#dc2626', margin: '0 0 12px' }}>⚠️ Ops, algo quebrou</h2>
          <div style={{ background: '#fee2e2', padding: '12px 16px', borderRadius: 6, marginBottom: 16, fontSize: 14 }}>
            <strong>{e.name}:</strong> {e.message}
          </div>
          {this.state.info?.componentStack && (
            <details style={{ marginBottom: 16 }}>
              <summary style={{ cursor: 'pointer', fontSize: 13, color: '#6b7280' }}>
                Mostrar detalhes técnicos (componentStack)
              </summary>
              <pre style={{
                background: '#f3f4f6', padding: 12, borderRadius: 6,
                fontSize: 11, overflow: 'auto', maxHeight: 300,
                color: '#374151',
              }}>{this.state.info.componentStack}</pre>
            </details>
          )}
          {e.stack && (
            <details>
              <summary style={{ cursor: 'pointer', fontSize: 13, color: '#6b7280' }}>
                Stack trace
              </summary>
              <pre style={{
                background: '#f3f4f6', padding: 12, borderRadius: 6,
                fontSize: 11, overflow: 'auto', maxHeight: 300,
                color: '#374151',
              }}>{e.stack}</pre>
            </details>
          )}
          <div style={{ marginTop: 20, display: 'flex', gap: 8 }}>
            <button onClick={() => location.reload()}
              style={{
                background: '#F15D22', color: '#fff', border: 'none',
                padding: '8px 16px', borderRadius: 6, cursor: 'pointer',
                fontWeight: 600,
              }}>
              🔄 Recarregar página
            </button>
            <button onClick={() => location.href = '/'}
              style={{
                background: '#fff', color: '#F15D22', border: '1.5px solid #F15D22',
                padding: '8px 16px', borderRadius: 6, cursor: 'pointer',
                fontWeight: 600,
              }}>
              🏠 Voltar à home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
